// Mock data for reports and analytics
export const reportsMockData = {
  summary: {
    total: 248,
    active: 156,
    pending: 52,
    closed: 40,
  },

  statusDistribution: [
    { 
      value: 156, 
      label: 'Active',
      color: {
        main: '#2E7D32',
        gradient: ['#43A047', '#1B5E20'],
      }
    },
    { 
      value: 52, 
      label: 'Pending',
      color: {
        main: '#ED6C02',
        gradient: ['#FF9800', '#E65100'],
      }
    },
    { 
      value: 40, 
      label: 'Closed',
      color: {
        main: '#0288D1',
        gradient: ['#29B6F6', '#01579B'],
      }
    },
  ],

  practiceAreaDistribution: [
    { 
      value: 85, 
      label: 'Personal Injury',
      color: {
        gradient: ['#1E88E5', '#0D47A1'],
      }
    },
    { 
      value: 62, 
      label: 'Family Law',
      color: {
        gradient: ['#7E57C2', '#4527A0'],
      }
    },
    { 
      value: 45, 
      label: 'Corporate Law',
      color: {
        gradient: ['#43A047', '#1B5E20'],
      }
    },
    { 
      value: 28, 
      label: 'Real Estate',
      color: {
        gradient: ['#FB8C00', '#E65100'],
      }
    },
    { 
      value: 18, 
      label: 'Criminal Defense',
      color: {
        gradient: ['#E53935', '#B71C1C'],
      }
    },
    { 
      value: 10, 
      label: 'Immigration',
      color: {
        gradient: ['#00ACC1', '#006064'],
      }
    },
  ],

  monthlyTrend: {
    months: ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar'],
    data: [28, 42, 35, 48, 52, 43],
  },
};